import { Directive, Input, Type, forwardRef } from "@angular/core";
import * as Fuse from "fuse.js";
import { Observable, of as observableOf } from "rxjs";

import { defaultThreshold } from "../../fuse/fuse-constants";
import {
  BaseDefaultOptionLayouts,
  BaseOptionsDirective,
  OptionsSourceQuery
} from "../base";
import { AdHocOption } from "./ad-hoc-option";
import { AdHocDefaultOptionLayoutsComponent } from "./ad-hoc-option-layouts.component";

@Directive({
  selector: "ta-select[options], ta-multi-select[options], ta-transfer-list[options]", // tslint:disable-line:directive-selector
  providers: [
    {
      provide: BaseOptionsDirective,
      useExisting: forwardRef(() => AdHocOptionsDirective)
    }
  ]
})
export class AdHocOptionsDirective<
  Identifier extends number | string
> extends BaseOptionsDirective<AdHocOption<Identifier>, Identifier> {
  defaultOptionLayoutsComponent: Type<
    BaseDefaultOptionLayouts<AdHocOption<Identifier>>
  > = AdHocDefaultOptionLayoutsComponent;

  @Input()
  set searchThreshold(value: number) {
    if (this._searchThreshold != null) {
      // tslint:disable-next-line:no-console
      console.warn(
        `${AdHocOptionsDirective.name} searchThreshold set multiple times.`
      );
    }
    this._searchThreshold = value;
  }
  get searchThreshold(): number {
    if (this._searchThreshold == null) {
      this._searchThreshold = defaultThreshold;
    }

    return this._searchThreshold;
  }
  _searchThreshold: number;

  @Input()
  get options(): Array<AdHocOption<Identifier>> {
    return this._options;
  }
  set options(value: Array<AdHocOption<Identifier>>) {
    if (this._options === value) {
      return;
    }

    this._options = value;
    this.optionsSearch = new Fuse(value, {
      keys: ["label", "value"],
      threshold: this.searchThreshold
    });

    this.optionsSourceChange.emit(this.optionsSource);
  }
  private _options: Array<AdHocOption<Identifier>>;
  private optionsSearch?: Fuse;

  optionsSource: (
    query?: OptionsSourceQuery
  ) => Array<AdHocOption<Identifier>> = (query) => {
    if (query == null || query.search == null || this.optionsSearch == null) {
      return this._options;
    }
    return this.optionsSearch.search(query.search);
  };

  readonly valueBy: "id" = "id";

  getModelsFromIdentifiers(
    identifiers: Identifier[]
  ): Observable<Array<AdHocOption<Identifier>>> {
    let identifierSet: Set<Identifier> = new Set(identifiers);
    if (this.options == null) {
      return observableOf([]);
    }
    return observableOf(
      this.options.filter((option) => {
        return identifierSet.has(option.value);
      })
    );
  }
  getIdentifierFromModel(model: AdHocOption<Identifier>): Identifier {
    return model.value;
  }
}
